import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';


@Injectable()
export class CoreService {

  private sidebarHiddenClass = 'sidebar-mini';
  private minWidth = 992;

  public sidebarOpen = new BehaviorSubject<boolean>(false);
  public sidebarOpen$ = this.sidebarOpen.asObservable();

  checkSidebar() {
    if (window.innerWidth <= this.minWidth) {
      this.sidebarOpen.next(false);
    } else {
      if (document.body.classList.contains(this.sidebarHiddenClass)) {
        this.sidebarOpen.next(true);
      }
    }
  }

  sidebarToggle() {
    this.sidebarOpen.next(!this.sidebarOpen.getValue());
  }

  navEndHappen() {
    if (window.innerWidth <= this.minWidth) {
      this.sidebarOpen.next(false);
    }
  }

  onClickOutOfMenu(e: any) {
    if (window.innerWidth <= this.minWidth) {
      this.sidebarOpen.next(false);
    }
  }

}
